namespace TerminalApp {


    export function CreateButton(iconUrl: string, buttonText: string): HTMLDivElement {
        var button = document.createElement("div");
        button.classList.add("noselect", "btn");

        if (iconUrl != null) {
            var icon = document.createElement("img");
            icon.classList.add("icon");
            icon.src = iconUrl;
            button.appendChild(icon);
        }

        if (iconUrl != null) {
            var text = document.createElement("span");
            text.classList.add("text", "big", "left");
            text.innerHTML = buttonText;
            button.appendChild(text);
        }

        return button;
    }

    export let ignoreHashChange = false;

    let appName = document.querySelector(".top .headline .app_name")

    export class AppBase {
        container: HTMLElement;
        id: string;
        is_open: boolean = false;
        constructor(id: string) {
            this.id = id;
            this.container = document.getElementById(this.id);
        }

        async onOpen() { };
        async onClose() { };

        async close() {
            if (this.is_open) {
                //remove active notifications
                SP.DismissAll();

                //set open state 
                this.is_open = false;

                //hide contianer
                this.container.style.transition = "";
                this.container.style.opacity = "0";
                this.container.style.display = "none";
                this.container.style.pointerEvents = "none";

                //leave app group
                await hub.connection.invoke("leaveGroup", this.id);

                //call app close event
                this.onClose();
            }
        }

        async open(params: { [name: string]: any } = {}) {
            //close running apps
            CloseAllApps();

            //start loading
            StartLoading();

            //set open state
            this.is_open = true;

            //set display and transistion of container
            this.container.style.display = "block";
            this.container.style.transition = "all ease-out 0.3s";

            //ignore haschanges and set hashes
            ignoreHashChange = true;
            params["app"] = this.id;
            SP.setAllHash(params);

            //join group and call app onopen
            await hub.connection.invoke("joinGroup", this.id);
            await this.onOpen();

            //delay for css opacity animation
            await SP.sleep(2);

            //click sound
            SP.Sounds.Click.play();

            //fade in container
            this.container.style.opacity = "1";
            this.container.style.pointerEvents = "auto";

            //revoke hash ignore
            ignoreHashChange = false;

            var name = this.container.getAttribute("data-name");
            if (name) appName.innerHTML = " ▸ " + name;
            else appName.innerHTML = "";
            //stop loading
            StopLoading();
        }
    }


   

}